import {Routes} from '@angular/router';
import {IncidentsPageComponent} from './pages/incidents-page';

export const routes: Routes = [
    { path: '', component: IncidentsPageComponent },
    { path: '**', redirectTo: '/' },
];
